export const SYMPTOM_SEVERITY = Object.freeze({
  NONE: 0,
  MILD: 1,
  MODERATE: 2,
  SEVERE: 3,
});

export const SYMPTOM_SEVERITY_OPTIONS = Object.freeze([
  {
    value: SYMPTOM_SEVERITY.NONE,
    labelKey: 'nkf.none',
    choiceLabelKey: 'nkf.symptomLibrary.notFelt',
  },
  { value: SYMPTOM_SEVERITY.MILD, labelKey: 'nkf.mild', choiceLabelKey: 'nkf.mild' },
  { value: SYMPTOM_SEVERITY.MODERATE, labelKey: 'nkf.moderate', choiceLabelKey: 'nkf.moderate' },
  { value: SYMPTOM_SEVERITY.SEVERE, labelKey: 'nkf.severe', choiceLabelKey: 'nkf.severe' },
]);

export const SYMPTOM_REPORTED_BY = Object.freeze({
  PATIENT: 'patient',
  CAREGIVER: 'caregiver',
});

export const SYMPTOM_HISTORY_FILTER = Object.freeze({
  ALL: 'all',
  ...SYMPTOM_REPORTED_BY,
});

export const MOOD_LEVEL = Object.freeze({ VERY_LOW: 1, LOW: 2, OKAY: 3, GOOD: 4, GREAT: 5 });

export const MOOD_OPTIONS = Object.freeze([
  {
    value: MOOD_LEVEL.GREAT,
    face: 'var(--mood-great-face)',
    color: 'var(--mood-great-ink)',
    background: 'var(--mood-great-soft)',
  },
  {
    value: MOOD_LEVEL.GOOD,
    face: 'var(--mood-good-face)',
    color: 'var(--success-button)',
    background: 'var(--success-soft)',
  },
  {
    value: MOOD_LEVEL.OKAY,
    face: 'var(--mood-okay-face)',
    color: 'var(--mood-okay-ink)',
    background: 'var(--warning-soft)',
  },
  {
    value: MOOD_LEVEL.LOW,
    face: 'var(--mood-low-face)',
    color: 'var(--orange)',
    background: 'var(--orange-soft)',
  },
  {
    value: MOOD_LEVEL.VERY_LOW,
    face: 'var(--mood-very-low-face)',
    color: 'var(--destructive-ink)',
    background: 'var(--destructive-soft)',
  },
]);

export const SYMPTOM_GRADE = Object.freeze({
  NONE: 'G0',
  MILD: 'G1',
  MODERATE: 'G2',
  SEVERE: 'G3',
});
// Chart severity (0-3) and badge colors for each API grade code.
export const SYMPTOM_GRADE_LEVEL = Object.freeze({
  [SYMPTOM_GRADE.NONE]: {
    severity: SYMPTOM_SEVERITY.NONE,
    color: 'var(--chart-label)',
    softColor: 'var(--secondary)',
  },
  [SYMPTOM_GRADE.MILD]: {
    severity: SYMPTOM_SEVERITY.MILD,
    color: 'var(--success)',
    softColor: 'var(--success-soft)',
  },
  [SYMPTOM_GRADE.MODERATE]: {
    severity: SYMPTOM_SEVERITY.MODERATE,
    color: 'var(--orange)',
    softColor: 'var(--orange-soft)',
  },
  [SYMPTOM_GRADE.SEVERE]: {
    severity: SYMPTOM_SEVERITY.SEVERE,
    color: 'var(--destructive)',
    softColor: 'var(--destructive-soft)',
  },
});
